var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"width":"500"}},[_c('v-system-bar',[_vm._v("Kursdokumente")]),_c('v-list',_vm._l((_vm.items),function(item){return _c('ReportItem',{key:item.id,attrs:{"value":item,"id":_vm.course.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }